import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ExamModal = ({ open, remainingQuestions, onClose, submit }) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
      setIsOpen(open)
  }, [open])

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Submeter respostas</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Você tem {remainingQuestions} perguntas não respondidas, deseja finalizar a prova e enviar suas respostas?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => submit()} variant="contained" color="primary" autoFocus style={{ width: 'auto' }}>
            Submeter
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ExamModal